import { css } from 'emotion';
import React from 'react';
import {
    FLOATING_DIALOG_TYPE_ARROW,
    FLOATING_DIALOG_TYPE_CORNER,
} from './floating-dialog-constants';
import './floating-dialog-style.scss';

export interface IFloatingDialogMargins {
    top?: number;
    bottom?: number;
    left?: number;
    right?: number;
}
export interface IFloatingDialogProps {
    arrowDialog?: 'top' | 'bottom';
    children?: React.ReactNode | React.ReactNode[];
    isDisplay?: boolean;
    position: { x: number; y: number };
    positionType?: 'arrow' | 'corner';
    removePanel?: () => void;
    viewport: { width: number; height: number };
    margins: IFloatingDialogMargins;
    verticalOffset?: number;
}

const FloatingDialog = (props: IFloatingDialogProps): React.ReactElement => {
    const {
        arrowDialog,
        children,
        position,
        positionType,
        viewport,
        margins,
        verticalOffset = 0,
    } = props;
    let innerClassName = '';
    const { x = 0, y = 0 } = position || {};
    let positionClasses = '';
    const {
        top: marginTop = 0,
        bottom: marginBottom = 0,
        right: marginRight = 0,
        left: marginLeft = 0,
    } = margins;
    const { width, height } = viewport;
    if (positionType === FLOATING_DIALOG_TYPE_ARROW) {
        innerClassName = 'box-scroll-arrow';
        const left = `${x * width + marginLeft}px`;
        const top = `${y * height + marginTop}px`;
        const styleArrowDialog = (arrowDialog || 'top').toLowerCase();

        positionClasses = `arrow-${styleArrowDialog}  
                 ${css`
                     left: ${left};
                     top: ${top};
                 `}`;
    } else if (positionType === FLOATING_DIALOG_TYPE_CORNER) {
        positionClasses = css({
            left: x <= 0.5 ? `${x * width + marginLeft}px` : 'auto',
            right: x > 0.5 ? `${(1 - x) * width + marginRight}px` : 'auto',
            top:
                y <= 0.5
                    ? `${y * height + marginTop + verticalOffset}px`
                    : 'auto',
            bottom:
                y > 0.5
                    ? `${(1 - y) * height + marginBottom + verticalOffset}px`
                    : 'auto',
        });
    }

    return (
        <div className={`box eds-text-color--grey-800 ${positionClasses}`}>
            <div className={`box-scroll ${innerClassName}`}>{children}</div>
        </div>
    );
};

export default FloatingDialog;
